import { features } from '@/mocks/siteInfo';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-sparkling-line text-sm"></i>
            平台亮点
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择禁漫天堂 JMComic
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm">
            六大核心优势，为您提供极致的漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 hover:translate-y-[-2px]"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}